import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewHomeView from '../views/NewHomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: NewHomeView
    },
    {
      path: '/old_home',
      name: 'old_home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/ContactView.vue')
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import("../views/PolicyView.vue")
    },
    {
      path: '/top_students1401',
      name: 'top_students1401',
      component: () => import('../views/TopStudents1401View.vue')
    },
    {
      path: '/top_students1402',
      name: 'top_students1402',
      component: () => import('../views/TopStudents1402View.vue')
    },
    {
      path: '/required_softwares',
      name: 'required-softwares',
      component: () => import('../views/RequiredSoftwaresView.vue')
    },
    {
      path: '/professor/:userId',
      name: 'professor',
      component: () => import( "@/views/NewProfessorView.vue"),
    },
    // {
    //   path: '/new_professor/:userId',
    //   name: 'new_professor',
    //   component: () => import( "@/views/NewProfessorView.vue"),
    // },
    {
      path: '/professor',
      name: 'professors',
      component: () => import("@/views/NewProfessorsView.vue"),
    },
    {
      path: '/courses/:courseId',
      name: 'course',
      props: true,
      component:()=> import("@/views/CourseView.vue")
    },
    {
      path: '/courses',
      name: 'courses',
      component: () => import("../views/CoursesView.vue"),
    },
    {
      path: '/courses/:courseId',
      name: 'customPackage',
      component: () => import("../views/CourseView.vue"),
    },
    {
      path: '/courses/:courseId',
      name: 'package',
      component: () => import("../views/CourseView.vue"),
    },
    {
      path: '/talented_students',
      name: 'talentedStudents',
      component: ()=>import('../views/TalentedStudentView.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: ()=>import('../views/FAQView.vue'),
    },
    {
      path: '/ostadino',
      name: 'ostadino',
      component: ()=> import('../views/OstadinoView.vue'),
    },
    {
      path: '/ostadino_policy',
      name: 'ostadino_policy',
      component: ()=> import('../views/OstadinoPolicyView.vue'),
    },
    {
      path: '/ostadino-detail/:professorId',
      name: 'ostadino-detail',
      component: ()=> import('../views/OstadinoTeacherDetailView.vue'),
    },
    {
      path: '/nomre-100-millioni',
      name: 'nomre_100_millioni',
      component: ()=> import('../views/MillionScoreView.vue'),
      meta: {
        layout: 'landing'
      }
    },
    {
      path: '/landing',
      name: 'landing',
      component: ()=> import('../views/landing/index.vue'),
      meta: {
        layout: 'landing'
      },
      children: [
        {
          path: '/planz',
          name: 'landing.planz',
          component: ()=> import('../views/landing/LandingPlanZ.vue')
        }
      ]
    },
    {
      path: '/yaldaOff',
      name: 'yaldaOff',
      redirect:{name: 'home'},
      component: ()=> import('../views/YaldaOffView.vue'),
      meta: {
        layout: 'landing'
      }
    },
    {
      path: '/live_classes',
      name: 'live_classes',
      component: ()=> import('../views/LiveClassesView.vue'),
    },
    {
      path: '/top_students1403',
      name: 'top_students1403',
      component: ()=> import('../views/TopStudents1403View.vue'),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('../views/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: 'error-404',
    },
  ]
})

export default router
